import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from "mobx-react";
import React from "react";
import { usePromoBanners } from "@faire/retailer-visitor-shared/stores/ui/usePromoBanners";
import { ImpAnimatedBanner } from "./PromoBanner/ImpAnimatedBanner";
var FaireValuesBannerBase = function() {
    var inProductMessagingBanners = usePromoBanners().inProductMessagingBanners;
    if (inProductMessagingBanners === null || inProductMessagingBanners === void 0 ? void 0 : inProductMessagingBanners.length) {
        return /*#__PURE__*/ _jsx(ImpAnimatedBanner, {
            banners: inProductMessagingBanners
        });
    }
    return null;
};
export var FaireValuesBanner = observer(FaireValuesBannerBase);
